import React from 'react';
import adminIco from '../assets/images/icon/admin.png';
import pharmIco from '../assets/images/icon/pharmacist.png';
import cashierIco from '../assets/images/icon/cashier.png';
import doctorIco from '../assets/images/icon/doctor.png';
import shape5 from '../assets/images/shape/5.png';
import shape12 from '../assets/images/shape/shape-12.png';
import ExternalLinks from '../Lib/ExternalLinks';

function DemoCredentials() {
    return (
        <>
            <section className="appie-blog-3-area appie-blog-8-area pt-90 pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="appie-section-title text-center">
                                <h3 className="appie-title">Available accounts</h3>
                                <p>The following accounts can be used to access the demo</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="appie-blog-item-3 appie-blog-item-8 mt-30">
                                <div className="thumb">
                                    <img src={adminIco} alt="" />
                                </div>
                                <div className="content">
                                    <h5 className="title">
                                        <a 
                                            href={ExternalLinks.demo_online} 
                                            title='Self-guided app tour'
                                            target='_blank' rel="noreferrer"
                                        >
                                            Administrator
                                        </a>
                                    </h5>
                                    <div className="meta-item">
                                        <ul>
                                            <li>
                                                <i className="fal fa-user"></i> John.Smow
                                            </li>
                                            <li>
                                                <i className="fal fa-lock"></i> Admin123!
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="appie-blog-item-3 appie-blog-item-8 mt-30">
                                <div className="thumb">
                                    <img src={cashierIco} alt="" />
                                </div>
                                <div className="content">
                                    <h5 className="title">
                                        <a
                                            href={ExternalLinks.demo_online} 
                                            title='Self-guided app tour'
                                            target='_blank' rel="noreferrer"
                                        >
                                            Cashier | Accountant
                                        </a>
                                    </h5>
                                    <div className="meta-item">
                                        <ul>
                                            <li>
                                                <i className="fal fa-user"></i> Brondon.Stark
                                            </li>
                                            <li>
                                                <i className="fal fa-lock"></i> Cashier123!
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="appie-blog-item-3 appie-blog-item-8 mt-30">
                                <div className="thumb">
                                    <img src={pharmIco} alt="" />
                                </div>
                                <div className="content">
                                    <h5 className="title">
                                        <a
                                            href={ExternalLinks.demo_online} 
                                            title='Self-guided app tour'
                                            target='_blank' rel="noreferrer"
                                        >
                                            Pharmacist | Stock manager
                                        </a>
                                    </h5>
                                    <div className="meta-item">
                                        <ul>
                                            <li>
                                                <i className="fal fa-user"></i> Jamy.Lanister
                                            </li>
                                            <li>
                                                <i className="fal fa-lock"></i> Pharmacist123!
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="appie-blog-item-3 appie-blog-item-8 mt-30">
                                <div className="thumb">
                                    <img src={doctorIco} alt="" />
                                </div>
                                <div className="content">
                                    <h5 className="title">
                                        <a
                                            href={ExternalLinks.demo_online} 
                                            title='Self-guided app tour'
                                            target='_blank' rel="noreferrer"
                                        >
                                            Recorder | Doctor
                                        </a>
                                    </h5>
                                    <div className="meta-item">
                                        <ul>
                                            <li>
                                                <i className="fal fa-user"></i> Rober.Baratheon
                                            </li>
                                            <li>
                                                <i className="fal fa-lock"></i> Recorder123!
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="appie-blog-8-shape-1">
                    <img src={shape5} alt="" />
                </div>
                <div className="appie-blog-8-shape-2">
                    <img src={shape12} alt="" />
                </div>
            </section>
        </>
    );
}

export default DemoCredentials;
